<template>
  <div class="container">
    <div class="bread">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item class="bread1" :to="{ path: '/' }"
          >| 首页</el-breadcrumb-item
        >
        <el-breadcrumb-item class="bread1"
          ><span style="color: red; user-select: none"
            >产权需求项目详细</span
          ></el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <!-- 项目图片轮播展示 -->
    <div style="position: relative; margin-bottom: 20px">
      <!-- height: 500px; -->
      <div style="display: flex">
        <div class="particulars">
          <div class="slideshow">
            <el-carousel
              :interval="5000"
              arrow="always"
              height="380px"
              ref="carousel"
            >
              <el-carousel-item
                v-for="(item, index) in projectDetail.imgList"
                :key="index"
              >
                <img
                  :src="item"
                  style="width: 100%; height: 380px; margin: 0 auto"
                />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="lunbo-bottom">
            <div
              v-for="(item, index) in projectDetail.imgList"
              :key="index"
              class="lunbo-item"
              @click="qiehuanlunbo(index)"
            >
              <img :src="item" style="width: 100%; height: 100%" />
            </div>
          </div>
        </div>
        <!-- 右侧商品详细栏 -->
        <div class="left-xiangqing">
          <div class="top-title">
            <div style="color: #f56c6c; font-weight: 700">
              {{ projectDetail.areaName + projectDetail.projectname }}
            </div>
            <div class="sub-title">
              <span>项目编码： {{ projectDetail.numbering }} </span
              ><span
                >发布时间：
                {{ timeDetail.createTime ? timeDetail.createTime : "" }}
              </span>
            </div>
          </div>
          <!-- height: 450px -->
          <div style="display: flex">
            <div class="left-bottom" style="flex: 1">
              <div>
                需求方名称：<span class="miaoshu">
                  {{ projectDetail.needname }}
                </span>
              </div>
              <div>
                联系人地址：<span class="miaoshu">
                  {{ projectDetail.address }}
                </span>
              </div>
              <div>
                联系人电话：<span class="miaoshu">
                  {{
                    (projectDetail.phone &&
                      projectDetail.phone.slice(0, 3) +
                        "*****" +
                        projectDetail.phone.slice(-3)) ||
                    "/"
                  }}
                </span>
              </div>
              <div>
                项目名称：<span class="miaoshu">
                  {{ projectDetail.projectname }}
                </span>
              </div>
              <div>
                承受价格：<span class="miaoshu">
                  {{ projectDetail.price }} 元/年/{{
                    getDictsVal(dicts.unitList, projectDetail.unit)
                  }}
                </span>
              </div>
              <div v-if="projectDetail.status > 6">
                中标价格：<span class="miaoshu">
                  {{ currentPrice }} 元/年/{{
                    getDictsVal(dicts.unitList, projectDetail.unit)
                  }}</span
                >
              </div>
              <div>
                报名人次：<span class="miaoshu">
                  {{ projectDetail.signCts }}人
                </span>
              </div>
              <div>
                浏览次数<span class="miaoshu">
                  {{ projectDetail.watchCts ? projectDetail.watchCts : 0 }}次
                </span>
              </div>
              <div
                v-if="projectDetail.status == 2 || projectDetail.status >= 7"
              >
                公示时间：<span class="miaoshu"
                  >{{ timeDetail.publicityStartTime }} 至
                  {{ timeDetail.publicityStopTime }}</span
                >
              </div>
              <div
                v-if="
                  (projectDetail.status <= 4 && projectDetail.status >= 2) ||
                  projectDetail.status >= 7
                "
              >
                报名时间：<span class="miaoshu"
                  >{{ timeDetail.applyStartTime }} 至
                  {{ timeDetail.applyStopTime }}</span
                >
              </div>
              <!-- v-if="detail.status==4" -->
              <div>
                竞价时间：<span class="miaoshu"
                  >{{ timeDetail.biddingStartTime }} 至
                  {{ timeDetail.biddingStopTime }}</span
                >
              </div>
              <!-- <div>降价幅度：<span class="miaoshu" >
                                    {{ parseInt(projectDetail.floatingPrice) }} 元</span></div> -->
              <div v-if="projectDetail.status == 6 && isApply">
                当前价格：<span class="miaoshu"
                  >{{ currentPrice }} 元/年/{{
                    getDictsVal(dicts.unitList, projectDetail.unit)
                  }}</span
                >
              </div>
              <div>
                降价幅度：<span class="miaoshu"
                  >{{ projectDetail.limitAmount }} 元/年/{{
                    getDictsVal(dicts.unitList, projectDetail.unit)
                  }}</span
                >
              </div>
              <!-- <div
                    style="max-width: 300px;border: 1px solid #606266;padding: 2px 10px;height: 60;display: flex;align-items: center;border-radius: 4px;">
                    <input placeholder="请输入..." type="number"
                      style="outline: none;font-size: 20px;height: 100%;border: 0;margin-right: 4px;" v-model.trim="money"
                      readonly :step="projectDetail.floatingPrice" :min="minMonery">元
                    :οninput="money = (money||'').replace(/[^A-z0-9]/, '')"
                  </div> -->

              <div
                style="display: flex; align-items: center; height: 50px"
                v-if="projectDetail.status == 6 && isApply == 1"
              >
                出价：

                <el-input
                  v-model="money"
                  class="input-number"
                  readonly
                ></el-input>
                元/年/{{ getDictsVal(dicts.unitList, projectDetail.unit) }}
                <!-- <div>
                                    <img src="@/assets/img/yijia.png"
                                        style="height: 30px;width: 30px;margin-left: 6px;">
                                    <span style="color: #ED222F;margin-left: 6px;">溢价率:{{ overRatio ? overRatio : '--'
                                        }}%</span>
                                </div> -->
              </div>
              <!-- v-if="projectDetail.status<=4" -->
              <!-- <div>浏览次数：<span class="miaoshu" >
                                    {{ projectDetail.watchCts ? projectDetail.watchCts : '0' }}
                                    次</span></div>
                            <div>报名人数：<span class="miaoshu" >
                                    {{ projectDetail.signCts ? projectDetail.signCts : '0' }}
                                    人</span></div> -->
              <!-- v-if="projectDetail.status==4" -->
              <!-- <div>竞价时间：<span class="miaoshu" >
                                    {{ timeDetail.biddingStartTime }} 至 {{ timeDetail.biddingStopTime }}
                                </span></div> -->

              <div class="gobutton" v-if="projectDetail.status == 2">
                公示中
              </div>
              <div class="gobutton1" v-if="projectDetail.status == 3">
                公示结束
              </div>
              <div
                class="gobutton"
                @click="toChanquanbaoming"
                v-if="projectDetail.status == 4 && isApply == 0"
              >
                我要报名
              </div>
              <div
                class="gobutton"
                v-if="projectDetail.status == 4 && isApply == 1"
              >
                报名成功
              </div>
              <div
                class="gobutton"
                v-if="projectDetail.status == 4 && isApply == 2"
              >
                已报名待审核
              </div>
              <div class="gobutton1" v-if="projectDetail.status == 5">
                报名结束
              </div>
              <div
                class="gobutton1"
                v-if="projectDetail.status == 6 && isApply == 1"
                @click="bid"
              >
                我要出价
              </div>
              <div
                class="gobutton1"
                v-if="projectDetail.status == 6 && isApply != 1"
              >
                未报名
              </div>

              <div
                class="gobutton1"
                v-if="projectDetail.status >= 7 && projectDetail.status < 19"
              >
                已结束
              </div>
            </div>
            <div
              style="
                flex: 1;
                padding: 0 16px;
                border-left: 1px solid #d9d9d9;
                margin: 16px 0;
                height: 400px;
              "
            >
              <div v-if="projectDetail.status < 4">
                距离报名开始：<span style="font-size: 28px; font-weight: 600"
                  >{{ nowDay }}天{{ nowHour }}时{{ nowMinute }}分{{
                    nowSecond
                  }}秒</span
                >
              </div>
              <div v-if="projectDetail.status == 4">
                距离报名截止仅剩<span style="font-size: 28px; font-weight: 600"
                  >{{ nowDay }}天{{ nowHour }}时{{ nowMinute }}分{{
                    nowSecond
                  }}秒</span
                >
              </div>
              <div v-if="projectDetail.status == 6">
                距离竞价截止仅剩<span style="font-size: 28px; font-weight: 600"
                  >{{ nowDay }}天{{ nowHour }}时{{ nowMinute }}分{{
                    nowSecond
                  }}秒</span
                >
              </div>
              <div style="display: flex; flex-direction: column; height: 100%">
                <div
                  style="
                    background-color: #f56c6c;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 10px 10px 0 0;
                  "
                >
                  <span
                    style="
                      color: #fff;
                      font-size: 30px;
                      font-family: Source Han Sans CN-Regular,
                        Source Han Sans CN;
                      padding: 8px 0;
                      font-weight: 400;
                      height: 54px;
                    "
                    ><span
                      v-if="
                        (projectDetail.status == 6 && isApply == 1) ||
                        cityDetail.showAuctionRecords
                      "
                      >出价记录</span
                    ></span
                  >
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    max-height: 85%;
                    overflow: auto;
                    padding: 0 20px;
                  "
                  v-if="
                    (projectDetail.status == 6 && isApply == 1) ||
                    cityDetail.showAuctionRecords
                  "
                >
                  <div
                    v-for="(data, index) in auctionRecords"
                    :key="index"
                    class="list"
                  >
                    <span style="flex: 1">{{
                      cityDetail.notShowAuctionRecordsName
                        ? "xxx"
                        : data.realname
                    }}</span>
                    <span style="flex: 2">{{ data.createTime }}</span>
                    <span
                      style="flex: 1; text-align: right; white-space: nowrap"
                      >{{ data.money }} 元/年/{{
                        getDictsVal(dicts.unitList, projectDetail.unit)
                      }}</span
                    >
                  </div>
                </div>
              </div>
              <div style="font-size: 20px; color: red">
                <i class="el-icon-warning"></i
                >重要提示:报价过程数据仅体现标的价格，不包含服务费!
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FLOW />
    <!-- 底部商品详细及交易须知 -->
    <div style="margin-top: 20px">
      <div
        style="
          display: flex;
          font-size: 28px;
          height: 70px;
          line-height: 70px;
          border-bottom: 1px solid black;
          background-color: #f7f7f7;
        "
      >
        <div
          @click="getDetailActive = 1"
          :class="getDetailActive == 1 ? 'getDetail' : 'getdetail'"
        >
          <a href="#xmxx" :class="getDetailActive == 1 ? 'gettimeDetail' : ''"
            >需求方信息</a
          >
        </div>
        <div
          @click="getDetailActive = 2"
          :class="getDetailActive == 2 ? 'getDetail' : 'getdetail'"
        >
          <a href="#jysj" :class="getDetailActive == 2 ? 'gettimeDetail' : ''"
            >需求项目信息</a
          >
        </div>
        <div
          @click="getDetailActive = 3"
          :class="getDetailActive == 3 ? 'getDetail' : 'getdetail'"
        >
          <a href="#tpzs" :class="getDetailActive == 3 ? 'gettimeDetail' : ''"
            >图片展示</a
          >
        </div>
        <div
          @click="getDetailActive = 4"
          :class="getDetailActive == 4 ? 'getDetail' : 'getdetail'"
        >
          <a href="#bmxz" :class="getDetailActive == 4 ? 'gettimeDetail' : ''"
            >报名须知</a
          >
        </div>
      </div>
      <div
        style="
          text-align: center;
          padding: 20px;
          padding-top: 40px;
          font-size: 24px;
        "
        class="conent"
      >
        <!-- <el-divider content-position="center">项目详细</el-divider>style="opacity:0" -->
        <div>
          <div class="footerTitle" id="xmxx"></div>
          <div>
            <div class="fengexian">
              <el-divider content-position="center">需求方信息</el-divider>
            </div>
          </div>
          <div style="display: flex">
            <div class="left" style="width: 50%; text-align: left">
              <div class="tet">
                <div class="tet1">需求方类型:</div>
                <div class="tet2">
                  <span>{{
                    getDictsVal(dicts.companyList, projectDetail.company)
                  }}</span>
                </div>
              </div>
              <div class="tet">
                <div class="tet1">电话:</div>
                <div class="tet2">
                  <span>{{
                    (projectDetail.phone &&
                      (showPhone
                        ? projectDetail.phone
                        : projectDetail.phone.slice(0, 3) +
                          "*****" +
                          projectDetail.phone.slice(-3))) ||
                    "/"
                  }}</span>
                  <img
                    src="../assets/img/closeEye.png"
                    style="width: 30px; height: 30px; cursor: pointer"
                    v-if="showPhone && cityDetail.cityName != '许昌市'"
                    @click="checkShowPhone"
                  />
                  <img
                    src="../assets/img/openEye.png"
                    style="width: 30px; height: 30px; cursor: pointer"
                    v-else-if="
                      projectDetail.phone && cityDetail.cityName != '许昌市'
                    "
                    @click="checkShowPhone"
                  />
                </div>
              </div>
              <div class="tet">
                <div class="tet1">联系人证件号码:</div>
                <div class="tet2">
                  <span>
                    {{
                      (projectDetail.idnum
                        ? projectDetail.idnum.slice(0, 4) +
                          "**********" +
                          projectDetail.idnum.slice(-4)
                        : "") || "/"
                    }}</span
                  >
                </div>
              </div>
              <div class="tet" v-if="projectDetail.company == 3">
                <div class="tet1">公司类型:</div>
                <div class="tet2">
                  <span>{{
                    getDictsVal(
                      dicts.companyTypeList,
                      projectDetail.companyType
                    )
                  }}</span>
                </div>
              </div>
              <div class="tet" v-if="projectDetail.company == 3">
                <div class="tet1">注册证号:</div>
                <div class="tet2">
                  <span>{{ projectDetail.registerNo || "/" }}</span>
                </div>
              </div>
              <div class="tet" v-if="projectDetail.company == 3">
                <div class="tet1">注册资本(万元):</div>
                <div class="tet2">
                  <span>{{ projectDetail.registerAmount || "/" }}</span>
                </div>
              </div>
              <!-- <div class="tet" v-if="projectDetail.company == 3">
                <div class="tet1">传真:</div>
                <div class="tet2">
                  <span >{{
                    projectDetail.fax
                  }}</span>
                </div>
              </div> -->
            </div>
            <div class="left" style="width: 50%; text-align: left">
              <div class="tet">
                <div class="tet1">名称:</div>
                <div class="tet2">
                  <span>{{ projectDetail.needname || "/" }}</span>
                </div>
              </div>
              <div class="tet">
                <div class="tet1">联系地址:</div>
                <div class="tet2">
                  <span>{{ projectDetail.address || "/" }}</span>
                </div>
              </div>
              <div class="tet" v-if="projectDetail.company == 3">
                <div class="tet1">公司名称:</div>
                <div class="tet2">
                  <span>{{ projectDetail.companyName || "/" }}</span>
                </div>
              </div>
              <!-- <div class="tet" v-if="projectDetail.company == 3">
                <div class="tet1">注册证号:</div>
                <div class="tet2">
                  <span >{{
                    projectDetail.registerNo
                  }}</span>
                </div>
              </div> -->
              <div class="tet" v-if="projectDetail.company == 3">
                <div class="tet1">法定代表人:</div>
                <div class="tet2">
                  <span>{{ projectDetail.legalperson || "/" }}</span>
                </div>
              </div>
              <div class="tet" v-if="projectDetail.company == 3">
                <div class="tet1">邮箱:</div>
                <div class="tet2">
                  <span>{{ projectDetail.email || "/" }}</span>
                </div>
              </div>
              <!-- <div class="tet" v-if="projectDetail.company == 3">
                <div class="tet1">邮编:</div>
                <div class="tet2">
                  <span >{{
                    projectDetail.postNo
                  }}</span>
                </div>
              </div> -->
              <!-- subType 类型补充 -->
              <div class="tet">
                <div class="tet1">标的类型:</div>
                <div class="tet2">
                  <span>{{ projectDetail.subType || "/" }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="border: 1px solid #fff">
          <div class="footerTitle" id="jysj"></div>
          <div>
            <div class="fengexian1">
              <el-divider content-position="center">需求项目信息</el-divider>
            </div>
          </div>
          <div style="display: flex">
            <div class="left" style="width: 50%; text-align: left">
              <div class="tet">
                <div class="tet1">位置区域:</div>
                <div class="tet2">
                  <span>{{ projectDetail.areaName || "/" }}</span>
                </div>
              </div>
              <div class="tet">
                <div class="tet1">数量:</div>
                <div class="tet3">
                  <span>{{ projectDetail.area || "/" }}</span>
                </div>
              </div>
              <div class="tet">
                <div class="tet1">承受价格:</div>
                <div class="tet3">
                  <span>{{
                    projectDetail.price +
                      "元/年/" +
                      getDictsVal(dicts.unitList, projectDetail.unit) || "/"
                  }}</span>
                </div>
              </div>
              <div class="tet" v-if="projectDetail.transType != 2">
                <div class="tet1">流转需求起始日期:</div>
                <div class="tet3">
                  <span>{{ projectDetail.needstarttime || "/" }}</span>
                </div>
              </div>
              <div
                class="tet"
                v-if="
                  projectDetail.number == 102 ||
                  projectDetail.number == 103 ||
                  projectDetail.number == 105 ||
                  projectDetail.number == 106 ||
                  projectDetail.number == 111 ||
                  projectDetail.number == 107 ||
                  projectDetail.number == 109
                "
              >
                <div class="tet1">地块应具备条件:</div>
                <div class="tet3">
                  <span>{{ projectDetail.condition || "/" }}</span>
                </div>
              </div>
              <div class="tet">
                <div class="tet1">项目类型:</div>
                <div class="tet3">
                  <span>{{
                    getClassList(classTypeList, projectDetail.number)
                  }}</span>
                </div>
              </div>
            </div>
            <div class="left" style="width: 50%; text-align: left">
              <div class="tet">
                <div class="tet1">项目名称:</div>
                <div class="tet2">
                  <span>{{ projectDetail.projectname || "/" }}</span>
                </div>
              </div>
              <div class="tet">
                <div class="tet1">数量单位:</div>
                <div class="tet2">
                  <span>{{
                    getDictsVal(dicts.unitList, projectDetail.unit)
                  }}</span>
                </div>
              </div>
              <div class="tet" v-if="projectDetail.transType != 2">
                <div class="tet1">需求年限（年）:</div>
                <div class="tet3">
                  <span>{{ getYearLimit() }} </span>
                </div>
              </div>
              <div class="tet" v-if="projectDetail.transType != 2">
                <div class="tet1">流转需求终止日期:</div>
                <div class="tet3">
                  <span>{{ projectDetail.needstoptime || "/" }}</span>
                </div>
              </div>
              <div
                class="tet"
                v-if="
                  projectDetail.number == 102 ||
                  projectDetail.number == 103 ||
                  projectDetail.number == 105 ||
                  projectDetail.number == 106 ||
                  projectDetail.number == 111 ||
                  projectDetail.number == 107 ||
                  projectDetail.number == 109
                "
              >
                <div class="tet1">转入用途:</div>
                <div class="tet3">
                  <span>{{ projectDetail.description || "/" }}</span>
                </div>
              </div>
              <div class="tet">
                <div class="tet1">交易方式:</div>
                <div class="tet3">
                  <span>{{
                    getDictsVal(dicts.transTypeList, projectDetail.transType)
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <!-- <div style="margin-top: 40px;" class="footerTitle" id="tpzs">图片展示</div> -->
          <div class="footerTitle" id="tpzs"></div>
          <div>
            <div class="fengexian1">
              <el-divider content-position="center">图片展示</el-divider>
            </div>
          </div>
          <div class="imgcontent">
            <el-image
              v-for="(item, index) in projectDetail.imgList"
              :key="index"
              style="
                width: 48%;
                height: auto;
                margin-left: 10px;
                margin-bottom: 10px;
              "
              :src="item"
              :preview-src-list="projectDetail.imgList"
            >
            </el-image>
          </div>
        </div>
        <div>
          <div class="footerTitle" id="bmxz"></div>
          <div>
            <div class="fengexian1">
              <el-divider content-position="center">报名须知</el-divider>
            </div>
          </div>
          <div
            style="
              text-align: left;
              line-height: 40px;
              font-size: 20px;
              margin-bottom: 40px;
              background-color: rgb(240, 248, 246);
              padding: 10px;
              box-sizing: border-box;
            "
            v-html="bmxzContent"
            v-if="bmxzContent"
          ></div>
          <div
            style="
              text-align: left;
              line-height: 40px;
              font-size: 20px;
              margin-bottom: 40px;
              background-color: rgb(240, 248, 246);
              padding: 10px;
              box-sizing: border-box;
            "
            v-else
          >
            <p>一、报名人持下列材料到本县农村产权交易服务中心报名：</p>
            <p>1、有效资格证件：</p>
            <p>
              （1）意向受让方为自然人，需提供本人身份证复印件或常住人口户口簿复印件；
            </p>
            <p>
              （2） 意向受让方为公司，需提供
              法定代表人身份证复印件、已年检的营业执照、开户行资信证明、开户行许可证、已年检组织机构代码证、已年检税务登记证、开发项目的可行性报告书、公司章程以及董事会或股东（大）会同意受让决议；
            </p>
            <p>
              （3）
              意向受让方为合作社，需提供法定代表人身份证复印件、已年检的营业执照、开户行资信证明、开户行许可证、已年检组织机构代码证、已年检税务登记证、开发项目的可行性报告书、合作社成员同意受让决议。
            </p>
            <p>2、若为授权人提出申请，需提供授权委托书及身份证复印件。</p>
            <p>
              二、挂牌期满，若征集到符合条件的意向受让方，采取协议或者竞标方式确定受让方。
            </p>
            <p>三、法定节假日、公休日不受理报名。</p>
            <!-- <p style="color: #F96226;">
  
              </p> -->
          </div>
        </div>
        <div>
          <!-- <div class="footerTitle" id="bmxz"></div> -->
          <div>
            <div class="fengexian1">
              <el-divider content-position="center">竞拍须知</el-divider>
            </div>
          </div>

          <div
            style="
              text-align: left;
              line-height: 40px;
              font-size: 20px;
              margin-bottom: 40px;
              background-color: rgb(240, 248, 246);
              padding: 10px;
              box-sizing: border-box;
            "
            v-if="jpxzContent"
            v-html="jpxzContent"
          ></div>

          <div
            v-else
            style="
              text-align: left;
              line-height: 40px;
              font-size: 20px;
              margin-bottom: 40px;
              background-color: rgb(240, 248, 246);
              padding: 10px;
              box-sizing: border-box;
            "
          >
            <p>
              一、交易保证金缴付方式及要求：
              意向受让方可选择网上银行转账、手机银行转账、银行柜面转账、线上支付方式缴付交易保证金。
              如果意向受让方未按规定方式缴付交易保证金，将会造成交易保证金无法退还，由此产生的一切后果和责任，由意向受让方自行承担。
            </p>
            <p>
              1、交纳保证金之前，意向受让方需到县农交中心官网挂牌交易项目中查看获取保证金账户信息；
            </p>
            <p>
              2、通过银行柜台转账的，在缴款时须在银行进账单或汇款凭证的备注/用途/附言栏中准确填写项目编号；
            </p>
            <p>
              3、通过网上银行/手机银行转账的，在缴款时须在网上银行支付界面的备注/用途/银行附言栏中准确填写项目编号；
            </p>
            <p>
              4、通过线上支付方式缴付的，意向受让方需留意报名界面提示的相关注意事项。
            </p>
            <p>二、交易保证金缴付注意事项：</p>
            <p>
              1、意向受让方报名时应准确填写银行账户信息，且保证填写的账户信息与保证金交纳账户信息一致。若因意向受让方未按要求填写相关信息而导致其无法参与竞价的，由此产生的一切后果和责任由意向受让方自行承担；
            </p>
            <p>
              2、意向受让方应妥善保管交易保证金缴款凭证，该凭证将作为查询及办理相关手续的依据之一。
            </p>
            <p>
              三、报名所需材料：（以农村产权转出公告中确定的受让方条件、与转让相关的其他条件为准）
            </p>
            <p>1、有效资格证明文件：</p>
            <p>
              （1）、意向受让方为自然人的，需提供有效期内本人身份证，意向受让方限制为村民或集体经济组织成员的，还需提供《身份认证承诺书》；
            </p>
            <p>
              （2）、意向受让方为单位的，需提供有效期内的营业执照副本、机构代码证、法定代表人身份、合作社章程/公司章程（封面盖章、骑缝盖章）、合作社成员大会决议/股东会决议/董事会决议。
            </p>
            <p>2、缴款凭证；</p>
            <p>3、其他材料。</p>
            <p>
              四、报名：
              交易保证金交纳后，点击“立即报名”按钮，填写报名信息，以附件形式上传交易保证金缴款凭证和报名所需材料的照片，竞价账户密码以意向受让方注册的为准。
            </p>
            <p>
              五、项目报名时间截止后，产生两个及以上符合条件的意向受让方的，{{
                deptName
              }}农村产权中心所按照公告的竞价方式组织或指导实施公开竞价。只产生一个符合条件的意向受让方的，{{
                deptName
              }}农村产权中心组织交易双方按挂牌价与意向受让方报价孰高（或孰低）原则直接签约；意向受让方未报价的，{{
                cityDetail.homeTitle
                  ? cityDetail.cityName + cityDetail.homeTitle
                  : cityDetail.cityName + "农村集体财产监督管理平台"
              }}组织交易双方按挂牌价直接签约。
            </p>
            <p>
              六、实行网络竞价的项目：意向受让方登录{{
                deptName
              }}农村产权交易信息服务网，点击“我要报名”按钮，凭报名时的用户名、密码登录竞价报名，在竞价报名截止时间之前进行报价。竞价结束后，按有效报价从高到低排序，选择报价最高者竞得项目（农村小微工程项目：竞价结束后，系统按有效报价从低到高排序，选择报价最低者竞得项目）。意向受让方报价不能低于项目挂牌价格（农村小微工程项目：报价不能高于项目挂牌价格），逾期报价或不符合规定的报价做无效处理。
            </p>
            <p>
              七、意向受让方承诺在确定为受让方后严格按照转出方的要求予以开发利用，不改变原用途，不破坏农业综合生产能力，不破坏生态环境，对于需提供开发利用规划的，及时提交规划文件。
            </p>
            <p>
              八、若非转出方原因，出现下列情形之一时，保证金不予退还，转出方可以意向受让方交纳的保证金为限，在扣除县农交中心的交易服务费用和相关方费用后，剩余部分作为补偿金划归转出方，并可继续向意向受让方主张相应的补偿责任：
            </p>
            <p>（一）、意向受让方交纳竞价保证金后单方撤回受让申请的；</p>
            <p>
              （二）、征集到两家及以上符合条件的意向受让方后，均未参与后续竞价程序的；或在竞价过程中以挂牌价格为起始价格，各意向受让方均不应价的；
            </p>
            <p>
              （三）、按照{{
                deptName
              }}农交中心有关制度、规则及通知要求，意向受让方竞价成功后，未在规定时间内签订合同的；或未按约定时限支付全部交易价款合同价款和交易服务费的；或未按交易条件的要求完成标的交付交接的；
            </p>
            <p>（四）、意向受让方故意提供虚假、失实材料造成转出方损失的；</p>
            <p>
              （五）、意向受让方通过获取转出方或标的企业的商业秘密，侵害转出方合法权益的；
            </p>
            <p>
              （六）、意向受让方之间相互串通，影响公平竞争，侵害转出方合法权益的；
            </p>
            <p>
              （七）、意向受让方在竞价过程中违反竞价规则和农村产权交易相关规则，扰乱竞价秩序的；
            </p>
            <p>
              （八）、意向受让方恶意炒作、操纵市场价格、出价严重偏离市场价格等非正当手段扰乱市场交易行为的；
            </p>
            <p>（九）、意向受让方违反法律法规或相关规定给转出方造成损失的；</p>
            <p>
              （十）、{{
                deptName
              }}农交中心认定的其他破坏正常交易秩序、不推进交易或放弃受让等违反公平、公正、诚实信用的行为；
            </p>
            <p>
              （十一）、意向受让方存在其他违反交易规则、挂牌条件要求的情形。
              保证金金额不足以弥补转出方、{{
                deptName
              }}农交中心或其他相关方损失的，利益受损方可以向有过错的意向受让方继续进行追偿。
            </p>
            <p>
              九、符合前款第（二)、（三）规定的，转出方有权向{{
                deptName
              }}农交中心申请重新挂牌。
            </p>
            <p>十、法定节假日、公休日不受理报名。</p>
            <p>十一、转出方有权在网络竞价开始前自行决定撤回网络竞价标的。</p>
            <p>
              十二、本平台对相关主体所发布的项目挂牌信息不作任何承诺和担保。意向受让方有意向应到标的物现场详细察看标的物的现状和瑕疵情况，对标的有明确的认识，若标的现状与项目公告内容有差异的，以标的现状为准，一经成交交易价格不作调整。
            </p>
            <p>十三、免责声明：</p>
            <p>
              （一）、{{
                cityDetail.homeTitle
                  ? cityDetail.cityName + cityDetail.homeTitle
                  : cityDetail.cityName + "农村集体财产监督管理平台"
              }}对转出方或意向受让方违反法律、法规或相关规定及违约行为不承担任何责任；
            </p>
            <p>
              （二）、若出现下列任何情况，{{
                cityDetail.homeTitle
                  ? cityDetail.cityName + cityDetail.homeTitle
                  : cityDetail.cityName + "农村集体财产监督管理平台"
              }}不承担任何经济责任和法律责任：
            </p>
            <p>
              1、对因不可抗力因素以及{{
                deptName
              }}农交中心系统故障、设备故障、通讯故障、电力故障等突发事故所产生的不可预测或不可控制因素造成损失的；
            </p>
            <p>
              2、网络竞价的时间以竞价系统服务器时间为准。由于意向受让方自身终端设备时间与网络竞价系统服务器时间不符而导致未能按时参与报价的；
            </p>
            <p>
              3、意向受让方因自身原因导致其注册账户信息泄露而造成的一切后果；
            </p>
            <p>
              4、意向受让方因遗忘密码、自身终端设备出现故障或网络异常而不能正常参与竞价的；
            </p>
            <p>
              5、意向受让方不符合受让方条件或因自身原因未及时关注项目公告逾期报名没有取得竞价资格的；
            </p>
            <p>6、其他因意向受让方自身原因导致未能报名或正常参与交易的。</p>
            <p>
              十四、郑重提醒意向受让方：报名前请仔细核对是否符合受让方条件并对竞价资格负责；{{
                cityDetail.homeTitle
                  ? cityDetail.cityName + cityDetail.homeTitle
                  : cityDetail.cityName + "农村集体财产监督管理平台"
              }}发现不符合规定和相关条件的有权驳回报名或取消资格；在取得“登录账号及密码”后，务必注意登录账号和密码的安全。凡使用该账号登入平台后所进行的一切报价及所做出的一切行为，均被视为账号所属注册用户的自主有效行为，该注册用户应对行为后果承担全部经济与法律责任。
            </p>
            <p>
              十五、意向受让方应认真阅读并正确理解本《报名须知》及《{{
                cityDetail.homeTitle
                  ? cityDetail.cityName + cityDetail.homeTitle
                  : cityDetail.cityName + "农村集体财产监督管理平台"
              }}网络竞价实施办法（试行）》《{{
                cityDetail.homeTitle
                  ? cityDetail.cityName + cityDetail.homeTitle
                  : cityDetail.cityName + "农村集体财产监督管理平台"
              }}收费管理办法（试行）》《网络竞价项目承诺函》《网络竞价须知》《现场看样确认函》《现场看样承诺函》等全部的条款及内容，意向受让方一旦登录{{
                cityDetail.homeTitle
                  ? cityDetail.cityName + cityDetail.homeTitle
                  : cityDetail.cityName + "农村集体财产监督管理平台"
              }}使用，即表示对上述全部条款及内容予以确认，无任何异议。
            </p>
          </div>
        </div>
        <div>
          <!-- <div class="footerTitle" id="bmxz"></div> -->
          <div>
            <div class="fengexian1">
              <el-divider content-position="center">特别提示</el-divider>
            </div>
          </div>

          <div
            style="
              text-align: left;
              line-height: 40px;
              font-size: 20px;
              margin-bottom: 40px;
              background-color: rgb(254, 246, 244);
              padding: 10px;
              box-sizing: border-box;
            "
          >
            <p>1、请竞买人按网站规范要求自主登录竞价系统进行竞价。</p>
            <p>
              2、竞买人应严格遵照约定的网络报价时间参与报价，因报价人原因造成报价不及时或失效的，相关责任由竞买人承担，请切勿错过时机；请竞买人确保终端设备运行良好。
            </p>
            <p>
              3、若发生项目暂停或中止情况，{{
                cityDetail.homeTitle
                  ? cityDetail.cityName + cityDetail.homeTitle
                  : cityDetail.cityName + "农村集体财产监督管理平台"
              }}网站发布公告为尽责告知义务。
            </p>
          </div>
        </div>

        <div>
          <!-- <div class="footerTitle" id="bmxz"></div> -->
          <div>
            <div class="fengexian1">
              <el-divider content-position="center">竞拍公告</el-divider>
            </div>
          </div>

          <table style="width: 100%" border="1">
            <tr>
              <th>标的名称</th>
              <td>
                {{ projectDetail.areaName + projectDetail.projectname }}
              </td>
            </tr>
            <tr>
              <th>项目编号</th>
              <td>
                {{ projectDetail.numbering }}
              </td>
            </tr>
            <tr>
              <th>报名及交纳交易保证金截止时间</th>
              <td>
                {{
                  timeDetail.applyStopTime
                }}前(以到账为准，逾期交纳保证金者报名无效)
              </td>
            </tr>
            <tr>
              <th rowspan="5">报（竞）价方式</th>

              <td>
                报名时间：{{ timeDetail.applyStartTime }} 至
                {{ timeDetail.applyStopTime }}
              </td>
            </tr>
            <tr>
              <td>
                竞价时间：{{ timeDetail.biddingStartTime }} 至
                {{ timeDetail.biddingStopTime }}
              </td>
            </tr>
            <tr>
              <td>交易方式：电子竞价</td>
            </tr>
            <tr>
              <td>竞价单位：{{ priceUnitList[projectDetail.unit] }}</td>
            </tr>
            <tr>
              <td>
                意向受让方通过网络电子竞价系统可在动态报价时间内充分自由报价，竞价时间截止，最低报价即成为成交价；无人出价则交易结束，项目不成交。
              </td>
            </tr>
          </table>
        </div>

        <div>
          <!-- <div class="footerTitle" id="bmxz"></div> -->
          <div>
            <div class="fengexian1">
              <el-divider content-position="center">风险告知</el-divider>
            </div>
          </div>

          <div
            style="
              text-align: left;
              line-height: 40px;
              font-size: 20px;
              margin-bottom: 40px;
              background-color: rgb(254, 246, 244);
              padding: 10px;
              box-sizing: border-box;
            "
          >
            <p>
              1.转出标的的合法性以及真实性由转出方负责，此次交易过程中存在相关交易风险及法律纠纷由交易双方自行承担并解决。
            </p>
            <p>
              2.{{
                deptName
              }}农村产权交易信息服务网不对农村产权流转交易信息的真实性、准确性、完整性做出任何保证。对任何因直接或间接使用本网站内容而造成的损失，包括但不限于因有关内容不真实、不准确、不完整而导致的损失，{{
                deptName
              }}农村产权交易信息服务网不承担任何法律责任。
            </p>
            <p>
              3.竞价标的物以实物现状为准，竞买人可以在挂牌期间申请实地看样，竞买人决定参与竞价的，视为对竞价标的物完全了解，并接受一切已知和未知瑕疵。{{
                deptName
              }}农村产权交易信息服务网和转出方均不承担瑕疵担保责任。
            </p>
          </div>
        </div>

        <div>
          <!-- <div class="footerTitle" id="bmxz"></div> -->
          <div>
            <div class="fengexian1">
              <el-divider content-position="center">竞买登记</el-divider>
            </div>
          </div>

          <table style="width: 100%" border="1">
            <tr>
              <th>投标方资格条件</th>
              <td></td>
            </tr>
            <tr>
              <th>报名方式</th>
              <td v-if="!applyWay">
                <p>1、意向受让方首次报名须知：</p>
                <p>
                  ①企业法人单位组织须提交加盖公章的《营业执照》复印件等证明主体资格的相关材料以及法定代表人身份证复印件、经办人身份证复印件、授权委托书、公章、法人章等相关材料；
                </p>
                <p>
                  ②非企业法人单位须提交以下资料：申请人身份证正反面复印件1份、申请人银行卡正反面复印件1份。
                </p>
                <p>
                  2、非首次报名的意向受让方按时根据保证金备注要求交纳交易保证金后即可参与本期竞价。
                </p>
                <p>
                  3、交易中心向意向受让方发放报价账号（长期有效、注意保管）。
                </p>
                <p>
                  4、交易保证金交纳截止日当天17:30前未收到交易账号激活短信的意向受让方，请致电交易中心。
                </p>
              </td>
              <td v-else v-html="applyWay"></td>
            </tr>
            <tr>
              <th>保证金及处理方式</th>
              <td>
                <p style="font-weight: 600">
                  1、须交纳的交易保证金金额为人民币{{
                    projectDetail.bailAmount
                  }}元。
                </p>
                <p style="font-weight: 600">
                  2、开户行:{{
                    backCardInfo
                      ? backCardInfo.bankName
                      : "中国建设银行股份有限公司信阳北京路支行"
                  }}
                </p>
                <p style="font-weight: 600">
                  户名:{{
                    backCardInfo
                      ? backCardInfo.cardName
                      : "信阳市申资产权交易有限责任公司"
                  }}
                </p>
                <p style="font-weight: 600">
                  账号:{{
                    backCardInfo ? backCardInfo.cardNo : "41001551417050201184"
                  }}
                </p>
                <p>
                  须在交纳保证金截止时间前电话通知交易中心已交纳保证金，如未通知或不得参与竞价。
                </p>
                <p>交纳交易保证金要求：</p>
                <p>
                  ①交易保证金可选择网上银行转账、手机银行转账、银行柜面转账、线上支付方式提交。
                </p>
                <p>② 交纳交易保证金时，须备注相关信息：</p>
                <p>企业：项目名称+企业名称。例：XX项目XX公司保证金；</p>
                <p>个人：项目名称+姓名。例：XX项目XX保证金；</p>
                <p>
                  交易保证金交易截止时间前未正确备注信息的，资格审查不予通过。
                </p>
                <p>
                  未成交者的交易保证金交易中心将在交易结束后15个工作日内全额无息返还。
                </p>
                <p>
                  ③竞拍人竞买成功后，携带相关资料到交易中心缴纳服务费，在交易中心主持下与出让方签订合同。
                </p>
                <p>
                  ④成交人交易保证金作为出让金转入出让方账户，溢价部分向出让方补缴齐。
                </p>
              </td>
            </tr>
          </table>
        </div>

        <div>
          <!-- <div class="footerTitle" id="bmxz"></div> -->
          <div>
            <div class="fengexian1">
              <el-divider content-position="center">交易方式</el-divider>
            </div>
          </div>

          <table style="width: 100%" border="1">
            <tr>
              <th>成交确认、价款支付及合同签订</th>
              <td>
                <p>
                  1、成交后，受让方应在两个工作日内到交易中心或转让方处领取《成交通知书》。标的成交的，受让方未在规定的时间内到交易中心或转让方处领取《成交通知书》的，交易中心将视作受让方知晓及认可相关交易内容，认可已成交标的相关权利和义务，如由此引发的一切法律纠纷由受让方自行承担，交易中心有权追究其相关法律责任。
                </p>
                <p>
                  2、受让方须在成交之次日起5个工作日内持《成交通知书》和付款凭证与招标方签订《招标合同》，约定双方相关的责任和义务；
                </p>
                <p>
                  3、受让方不根据本公告要求履约的，视为自动放弃受让资格，其已交纳的交易保证金不予退回，并对交易中心因此造成的损失承担赔偿责任，招标方有权将该标重新组织竞买交易。
                </p>
              </td>
            </tr>
            <tr>
              <th>投标方资格条件</th>
              <td>双方按相关合同约定进行交割。</td>
            </tr>
          </table>
        </div>

        <div>
          <!-- <div class="footerTitle" id="bmxz"></div> -->
          <div>
            <div class="fengexian1">
              <el-divider content-position="center">其他事项</el-divider>
            </div>
          </div>

          <div
            style="
              text-align: left;
              line-height: 40px;
              font-size: 20px;
              margin-bottom: 40px;
              background-color: rgb(240, 248, 246);
              padding: 10px;
              box-sizing: border-box;
            "
          >
            <p>
              1、意向受让方参与交易前应仔细阅读本信息公告、“附件”中所有材料、阅读了解{{
                deptName
              }}农村综合产权交易中心相关交易规则等有关材料，一旦参与交易（报名）则视为意向受让方已充分了解并接受信息公告（含附件材料）、{{
                deptName
              }}农村综合产权交易中心交易规则等全部内容，愿意承担可能存在的一切交易风险。
            </p>
            <p>
              2、{{ deptName }}农村综合产权交易中心相关交易规则请查看{{
                deptName
              }}农村综合产权交易中心官网：交易指南 — 交易规则
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkToken, getUserInfoByUserId } from '../api/login'
import { getProList } from '../api/交易项目'
import {
  auctionBid,
  getCurrentPrice,
  getTypeList,
  isApply,
  watchProject,
  getBankCardInfo,
  getInfoByDeptId,
} from '../api/交易项目详情'
import FLOW from "../components/Home/First/交易流程.vue"
import { getNeedProjectDetail } from '../api/产权需求'
import { cityDetail } from '../util/mainOption'
import { getNewsDetail, getNewslist } from '../api/mian'
export default {
  data () {
    return {
      // 查看区域下标
      getDetailActive: '1',
      // 当前地级名称
      deptName: '',
      // 项目详情
      projectDetail: {},
      // 时间详情
      timeDetail: {},
      // 出价记录
      auctionRecords: [],
      // 交纳保证金账户信息
      backCardInfo: {},
      // 当前价格
      currentPrice: -999,
      // 计时器
      timer: null,
      // 当前天数
      nowDay: 0,
      // 当前小时
      nowHour: 0,
      // 当前分钟
      nowMinute: 0,
      // 当前秒数
      nowSecond: 0,
      // 账户报名状态
      isApply: 0, //0未报名,1已报名2已报名未审核
      // 价格计时器
      priceTimer: null,
      // 当前出价金额
      money: '',
      // token验证是否通过
      chechTokenRes: false,
      // 字典列表
      dicts: {
        // 小类型列表
        numberList: [],
        // 需求方类型列表
        companyList: [],
        // 公司类型列表
        companyTypeList: [],
        // 交易方式列表
        transTypeList: [],
        // 单位列表
        unitList: [],
      },
      // 小分类列表
      classTypeList: [],
      accomplish1: false,
      accomplish: false,
      userInfo: {},
      showPhone: false,
      // 报名方式 html
      applyWay: "",
      // 报名须知 html
      bmxzContent: "",
      // 竞拍须知 html
      jpxzContent: "",
    }
  },
  components: {
    FLOW,
  },
  async mounted () {
    getNewslist({
      number: '021',
      pageSize: 10,
      pageNum: 1,
      deptId: sessionStorage.getItem('deptId') || cityDetail.deptId,
    }).then(res => {
      res.data.rows.length > 0 && getNewsDetail({ id: res.data.rows[0].id }).then(res => {
        this.applyWay = res.data.data.content
        console.log("报名方式新闻详情", this.applyWay)
      })
    })
    getNewslist({
      number: '022',
      pageSize: 1,
      pageNum: 1,
      deptId: sessionStorage.getItem('deptId') || cityDetail.deptId,
    }).then(res => {
      res.data.rows.length > 0 && getNewsDetail({ id: res.data.rows[0].id }).then(res => {
        this.bmxzContent = res.data.data.content
        console.log("报名须知新闻详情", this.bmxzContent)
      })
    })
    getNewslist({
      number: '023',
      pageSize: 1,
      pageNum: 1,
      deptId: sessionStorage.getItem('deptId') || cityDetail.deptId,
    }).then(res => {
      res.data.rows.length > 0 && getNewsDetail({ id: res.data.rows[0].id }).then(res => {
        this.jpxzContent = res.data.data.content
        console.log("竞拍须知新闻详情", this.jpxzContent)
      })
    })
    if (this.$route.query.id) {
      await getNeedProjectDetail(this.$route.query).then((res) => {
        if (!res.data.data) {
          this.$message.error('无该项目信息')
          return
        }
        this.projectDetail = res.data.data

        // console.log('请求成功')
        getInfoByDeptId(this.projectDetail.pid).then((res) => {
          // console.log('res', res)
          this.backCardInfo = res.data.data
        })
      })
    }
    getProList({ type: 3 }).then((res) => {
      // console.log('已打印')
      this.classTypeList = res.data.data
    })
    getTypeList('poperty_type').then((res) => {
      this.dicts.numberList = res.data.data
    })
    getTypeList('need_type').then((res) => {
      this.dicts.companyList = res.data.data
    })
    getTypeList('company_type').then((res) => {
      this.dicts.companyTypeList = res.data.data
    })
    getTypeList('trans_type').then((res) => {
      this.dicts.transTypeList = res.data.data
    })
    getTypeList('area_unit').then((res) => {
      this.dicts.unitList = res.data.data
    })
    this.deptName = localStorage.getItem('deptName')
      ? localStorage.getItem('deptName')
      : this.cityDetail.cityName
    this.timeDetail = this.projectDetail.releaseRecord
    getCurrentPrice({
      projectId: this.$route.query.id,
      projectType: 3,
    }).then((res) => {
      this.currentPrice = res.data.data.currentPrice
        ? res.data.data.currentPrice
        : res.data.data.initPrice
      this.auctionRecords = res.data.data.auctionRecords
      this.money = !res.data.data.currentPrice ? res.data.data.initPrice : ((Number(this.currentPrice) - Number(this.projectDetail.limitAmount) >= 0) ? (Number(this.currentPrice) - Number(this.projectDetail.limitAmount)) : 0)
    })
    if (localStorage.getItem('token')) {
      checkToken().then((res) => {
        if (res.data.code == 200) {
          this.chechTokenRes = true
          getUserInfoByUserId().then((res) => {
            this.userInfo = res.data.data
          })
          isApply({ projectId: this.projectDetail.id, projectType: 3 }).then(
            (res) => {
              this.isApply = res.data.data
              getCurrentPrice({
                projectId: this.$route.query.id,
                projectType: 3,
              }).then((res) => {
                this.currentPrice = res.data.data.currentPrice
                  ? res.data.data.currentPrice
                  : res.data.data.initPrice
                this.money = !res.data.data.currentPrice ? res.data.data.initPrice : ((Number(this.currentPrice) - Number(this.projectDetail.limitAmount) >= 0) ? (Number(this.currentPrice) - Number(this.projectDetail.limitAmount)) : 0)

                this.auctionRecords = res.data.data.auctionRecords
              })
            }
          )
        }
      })
    }
    this.rebootCountDown()
    watchProject({ dataId: this.projectDetail.id, type: 3 })
  },
  methods: {
    checkShowPhone () {
      this.showPhone = !this.showPhone
    },
    // 获取小分类列表
    getClassList (list, id) {
      return list.filter((item) => {
        return item.code == id
      })[0]
        ? list.filter((item) => {
          return item.code == id
        })[0].name
        : ''
    },
    // 获取字典内容方法
    getDictsVal (list, val) {
      if (!!list && !!val) {
        return list.filter((item) => {
          return item.dictValue == val
        })[0]
          ? list.filter((item) => {
            return item.dictValue == val
          })[0].dictLabel
          : ''
      }
      return ''
    },
    getYearLimit () {
      let start = new Date(this.projectDetail.needstarttime)
      let stop = new Date(this.projectDetail.needstoptime)
      return (
        (Number(stop.getTime()) - Number(start.getTime())) /
        (1000 * 60 * 60 * 24 * 30 * 12)
      ).toFixed(1)
    },
    bid () {
      if (this.auctionRecords.length > 0 && this.userInfo.name == this.auctionRecords[0].realname) {
        this.$message.warning('您是当前最低出价人,请等待其他出价人')
        getCurrentPrice({
          projectId: this.$route.query.id,
          projectType: 3,
        }).then((res) => {
          this.currentPrice = res.data.data.currentPrice
            ? res.data.data.currentPrice
            : res.data.data.initPrice
          this.money = !res.data.data.currentPrice ? res.data.data.initPrice : ((Number(this.currentPrice) - Number(this.projectDetail.limitAmount) >= 0) ? (Number(this.currentPrice) - Number(this.projectDetail.limitAmount)) : 0)
          this.auctionRecords = res.data.data.auctionRecords
        })
        return
      }
      if (
        Number(this.currentPrice) - Number(this.money) >=
        this.projectDetail.limitAmount ||
        Number(this.money) >= 0
      ) {
        auctionBid({
          projectId: this.projectDetail.id,
          projectType: 3,
          money: this.money,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$message.success('出价成功')
            getCurrentPrice({
              projectId: this.$route.query.id,
              projectType: 3,
            }).then((res) => {
              this.currentPrice = res.data.data.currentPrice
                ? res.data.data.currentPrice
                : res.data.data.initPrice
              this.money = !res.data.data.currentPrice ? res.data.data.initPrice : ((Number(this.currentPrice) - Number(this.projectDetail.limitAmount) >= 0) ? (Number(this.currentPrice) - Number(this.projectDetail.limitAmount)) : 0)
              this.auctionRecords = res.data.data.auctionRecords
            })
          }
        })
      } else {
        getCurrentPrice({
          projectId: this.$route.query.id,
          projectType: 3,
        }).then((res) => {
          this.currentPrice = res.data.data.currentPrice
            ? res.data.data.currentPrice
            : res.data.data.initPrice
          this.money = !res.data.data.currentPrice ? res.data.data.initPrice : ((Number(this.currentPrice) - Number(this.projectDetail.limitAmount) >= 0) ? (Number(this.currentPrice) - Number(this.projectDetail.limitAmount)) : 0)
          this.auctionRecords = res.data.data.auctionRecords
          this.$message.error('降价须大于最低降价')
        })
      }
    },
    // 获取当前价格
    getNowPrice () {
      if (this.accomplish1) {
        return
      }
      this.accomplish1 = true
      setTimeout(() => {
        getCurrentPrice({ projectId: this.$route.query.id, projectType: 3 })
          .then((res) => {
            this.currentPrice = res.data.data.currentPrice
              ? res.data.data.currentPrice
              : res.data.data.initPrice
            this.money = !res.data.data.currentPrice ? res.data.data.initPrice : ((Number(this.currentPrice) - Number(this.projectDetail.limitAmount) >= 0) ? (Number(this.currentPrice) - Number(this.projectDetail.limitAmount)) : 0)
            this.auctionRecords = res.data.data.auctionRecords
            this.accomplish1 = false
          })
          .catch((err) => {
            this.accomplish1 = false
          })
      }, 10000)
    },
    // 重启计时器方法
    rebootCountDown () {
      this.timer = setInterval(async () => {
        let time
        if (this.projectDetail.status < 4) {
          time = await this.countDown(this.timeDetail.applyStartTime)
        } else if (this.projectDetail.status == 4) {
          time = await this.countDown(this.timeDetail.applyStopTime)
        } else if (this.projectDetail.status == 6) {
          time = await this.countDown(this.timeDetail.biddingStopTime)
          if (this.isApply == 1) {
            this.getNowPrice()
          }
        } else {
          clearInterval(this.timer)
          return
        }
        this.nowDay = time.day
        this.nowHour = time.hour
        this.nowMinute = time.minute
        this.nowSecond = time.second
        if (!time.day && !time.hour && !time.minute && !time.second) {
          clearInterval(this.timer)
          if (this.accomplish) {
            return
          }
          this.accomplish = true
          setTimeout(() => {
            this.getProjectDetail()
            this.accomplish = false
          }, 5000)
          return
        }
      }, 1000)
    },
    // 倒计时方法
    countDown (endTime) {
      let now = new Date().getTime()
      let end = new Date(endTime).getTime()
      let time = {
        day: 0,
        hour: 0,
        minute: 0,
        second: 0,
      }
      if (now >= end) {
        return time
      }
      time.day = Math.floor((Number(end) - Number(now)) / (1000 * 60 * 60 * 24))
      time.hour = Math.floor(
        (Number(end) - Number(now) - time.day * 1000 * 60 * 60 * 24) /
        (1000 * 60 * 60)
      )
      time.minute = Math.floor(
        (Number(end) -
          Number(now) -
          (time.day * 1000 * 60 * 60 * 24 + time.hour * 1000 * 60 * 60)) /
        (1000 * 60)
      )
      time.second = Math.floor(
        (Number(end) -
          Number(now) -
          (time.day * 1000 * 60 * 60 * 24 +
            time.hour * 1000 * 60 * 60 +
            time.minute * 1000 * 60)) /
        1000
      )
      return time
    },
    // 报名按钮事件
    toChanquanbaoming () {
      if (localStorage.getItem('token') && this.chechTokenRes) {
        this.$router.push({
          name: '产权报名',
          query: { id: this.projectDetail.id, type: 3 },
        })
      } else {
        this.$message.error('请先登录')
        if (cityDetail.homeShowLogin) {
          this.$router.push('/')
        } else {
          this.$router.push('/login')
        }
      }
    },
    // 获取项目详情
    getProjectDetail () {
      if (this.$route.query.id) {
        getNeedProjectDetail(this.$route.query).then((res) => {
          if (!res.data.data) {
            this.$message.error('无该项目信息')
            return
          }
          this.projectDetail = res.data.data
          if (this.projectDetail.status <= 6) {
            this.rebootCountDown()
          }
        })
      }
    },
    // 限制降价框输入
    btKeyDown (e) {
      e.target.value = e.target.value.replace(/[^0-9]/g, '')
    },
  },
}
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.imgcontent {
  display: flex;
  /* justify-content: s; */
  flex-wrap: wrap;
}

.lunbo-bottom {
  display: flex;
  /* border: 1px solid red; */
  margin-top: 7px;
  height: 110px;
}

.lunbo-item {
  width: 25%;
  margin-right: 5px;
  cursor: pointer;
}

.lunbo-item:last-child {
  margin-right: 0;
}

.top-title {
  height: 85px;
  border-bottom: #d1d1d2 1px solid;
  padding-left: 30px;
}

.left-bottom {
  font-size: 20px;
  padding: 30px;
  color: #666;
}

.left-bottom > div {
  line-height: 45px;
  height: 45px;
}

.gobutton {
  width: 200px;
  text-align: center;
  margin: 0 auto;
  background-color: #67c23a;
  border-radius: 10px;
  font-size: 25px;
  color: #fff;
  cursor: pointer;
  user-select: none;
}

.gobutton1 {
  width: 200px;
  text-align: center;
  margin: 0 auto;
  background-color: #f56c6c;
  border-radius: 10px;
  font-size: 25px;
  color: #fff;
  cursor: pointer;
  user-select: none;
  margin-top: 20px;
}

.miaoshu {
  color: #333;
}

.sub-title {
  color: #999;
  font-size: 18px;
  margin-top: 15px;
}

.sub-title span {
  margin-right: 50px;
}

.left-xiangqing {
  border: 1px solid #d1d1d2;
  flex: 1;
  margin-left: 30px;
  font-size: 26px;
  padding: 15px 0;
  color: #333;
}

* {
  padding: 0;
  margin: 0;
}

a {
  text-decoration: none;
  color: black;
}

.container {
  margin: 0 auto;
  width: 1860px;
  background-color: #fff;
  padding: 20px;
}

.bread {
  margin: 20px 0;
}

.bread1 {
  font-size: 18px;
}

.particulars {
  width: 30%;
  height: 100%;
}

.slideshow {
  width: 100%;
  /* height: 400px; */
  /* margin-top: 3%; */
  /* margin: /auto 0; */
}

.footer {
  display: flex;
  font-size: 22px;
}

.footerDiv {
  margin: 8px 0;
  font-weight: 600;
}

.footerTitle {
  font-size: 36px;
  height: 15px;
  /* border: #67C23A 1px solid; */
  /* margin-bottom: 40px; */
  color: #f56c6c;
  /* list-style: armenian; */
}

.fengexian {
  margin-bottom: 40px;
}

.fengexian >>> .el-divider__text {
  font-size: 36px;
  /* margin-bottom: 40px; */
  color: #f56c6c;
  list-style: armenian;
}

.fengexian1 {
  margin: 30px 0 50px 0;
}

.fengexian1 >>> .el-divider__text {
  font-size: 36px;
  /* margin-bottom: 40px; */
  color: #f56c6c;
  list-style: armenian;
}

.applyDetail {
  width: 85%;
  height: 55%;
  border: 1px solid #d1d1d2;
}

.left > div {
  margin: 25px 0;
}

.getdetail {
  font-size: 24px;
  padding: 0 30px;
  font-weight: 600;
  opacity: 0.5;
}

.getDetail {
  font-size: 24px;
  padding: 0 30px;
  border-top: 1px solid #f56c6c;
  background-color: white;
}

.gettimeDetail {
  color: #f56c6c;
  font-weight: 600;
}

.tet {
  border: 1px solid rgb(210, 210, 210);
  /* padding: 30px; */
  margin: 0 !important;
  display: flex;
}

.tet1 {
  min-width: 250px;
  max-width: 250px;
  border-right: 1px solid #f3f5f8;
  padding: 20px 20px;
  text-align: center;
  font-weight: 600;
  background-color: #f3f5f8;
}

.tet2 {
  padding: 20px 20px;
  width: 550px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tet3 {
  padding: 20px 20px;
  width: 550px;
  overflow: hidden;
  text-overflow: ellipsis;
  /* width: 100%; */
}

.money {
  display: flex;
  flex-direction: column;
}

.moneyTableTitle {
  display: flex;
  align-content: center;
}

.mtt {
  flex: 1;
  border: 1px solid #d2d2d2;
  padding: 20px;
  font-weight: 600;
  background-color: #f3f5f8;
}

.mtc {
  flex: 1;
  border: 1px solid #d2d2d2;
  padding: 20px;
}

.list {
  font-size: 20px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #606266;
  padding: 10px 0;
  border-bottom: 1px solid #606266;
  display: flex;
  justify-content: space-between;
}

.list:last-child {
  border-bottom: 0;
}

table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  padding: 0;
  margin: 0;
  height: 100%;
}

table td {
  height: auto;
  text-align: left;
  table-layout: fixed;
  padding: 10px 6px;
  font-size: 20px;
  line-height: 100%;
  color: #000000;
  line-height: 40px;
}

table th {
  width: 15%;
  height: auto;
  text-align: left;
  table-layout: fixed;
  padding: 10px 6px;
  font-size: 20px;
  line-height: 100%;
  color: #000000;
  background: #fafafa;
  font-weight: normal;
}

.input-number {
  /* transform: scale(1.25); */
  width: 200px;
}

.input-number >>> .el-input__inner {
  width: 200px;
  text-align: right;
  font-size: 24px !important;
  font-weight: bold !important;
}
.conent > div {
  margin: 10px 0;
}
</style>
